import { styled } from '@mui/system'
import { colors, fontSizes } from '../../consts'

type stylesProps = {
  color?: string
  uiTheme?: 'light' | 'dark'
  size?: 'home_featured' | 'normal' | 'small' | 'featured'
  backgroundImg?: string
}

export const VideoCardCon = styled('div')<stylesProps>(({ size, uiTheme, theme }) => ({
  '& .cover': {
    borderRadius: theme.spacing(1),
    width: '100%',
    backgroundColor: colors.gray.gray20,
  },
  '& .placeholder': {
    borderRadius: theme.spacing(1),
    objectFit: 'cover',
  },
}))

export const BlurredBackground = styled('div')<stylesProps>(
  ({ backgroundImg, theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    aspectRatio: '16/9',
    borderRadius: 8,
    top: 0,
    left: '50%',
    transform: `translateX(-50%)`,
    filter: `blur(5px)`,
    overflow: 'hidden',
    width: '100%',
    zIndex: -1
  })
)

export const VideoThumb = styled('div')<stylesProps>(({ size, theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 8,
  overflow: 'hidden',
  cursor: 'pointer',
  zIndex: 1,
  '& .imgCon': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    '& img': {
      height: '100%',
      objectFit: 'cover',
    },
  },
  '& .playBtn': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 3,
  },
  '& .durationCon': {
    position: 'absolute',
    left: 5,
    bottom: 8,
    borderRadius: 12,
    background: `${colors.offWhite}98`,
    padding: theme.spacing(0.5, 1.5),
    [theme.breakpoints.between('md', 'lg')]: {
      bottom: 6,
    },
    [theme.breakpoints.down('md')]: {
      bottom: 5,
      padding: theme.spacing(0.25, 1),
    },
    '& .durationText': {
      fontSize: fontSizes.small,
      color: colors.black,
      fontWeight: 'bold',
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        fontSize: fontSizes.xSmall,
      },
    },
  },
}))

export const VideoTitle = styled('h2')<stylesProps>(({ uiTheme, theme }) => ({
  fontWeight: 'bold',
  fontSize: fontSizes.medium,
  color: uiTheme === 'dark' ? colors.white : colors.text,
  lineHeight: '120%',
  marginTop: theme.spacing(1),
  alignSelf: 'flex-start',
  gridColumn: '1 / -1',
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))

export const FullVideoCon = styled('div')<stylesProps>(({ theme }) => ({
  display: 'flex',
  width: '100vw',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
}))
